import type { SxProps, Theme } from '@mui/material/styles';
import SvgIcon from '@mui/material/SvgIcon';

type Props = {
	sx?: SxProps<Theme>;
};

export const AddItemIcon = ({ sx }: Props) => {
	return (
		<SvgIcon width='15' height='15' viewBox='0 0 15 15' fill='none' sx={sx}>
			<svg
				width='15'
				height='15'
				viewBox='0 0 15 15'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
			>
				<path
					d='M8.25 3.75H6.75V6.75H3.75V8.25H6.75V11.25H8.25V8.25H11.25V6.75H8.25V3.75ZM7.5 0C3.3675 0 0 3.3675 0 7.5C0 11.6325 3.3675 15 7.5 15C11.6325 15 15 11.6325 15 7.5C15 3.3675 11.6325 0 7.5 0ZM7.5 13.5C4.1925 13.5 1.5 10.8075 1.5 7.5C1.5 4.1925 4.1925 1.5 7.5 1.5C10.8075 1.5 13.5 4.1925 13.5 7.5C13.5 10.8075 10.8075 13.5 7.5 13.5Z'
					fill='currentColor'
				/>
			</svg>
		</SvgIcon>
	);
};
